import styled from 'styled-components';

export const Left = styled.div`
  position: absolute;
  left: 0;
  width: 10px;
  height: 100%;

  transform: translateX(-50%);

  cursor: w-resize;
`;
